module.exports = __webpack_public_path__ + "img/languageScore2.88898d41.png";